import React, { useMemo } from "react";
import { OverlaySelectors } from "../../redux/selectors";
import { VisibleSpinner } from "./Spinner";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { IgnoreClickOutsideAttribute } from "../../constants";

export const Overlay = () => {
  const current = useSelector(OverlaySelectors.current);
  const isVisible = useSelector(OverlaySelectors.isVisible);

  const {
    className,
    title,
    content,
    action,
    buttonTitle,
    showOverlayContent,
    showOverlaySpinner,
    isIgnoredClickOutside
  } = current || {};

  const classes = useMemo(
    () =>
      classNames(
        "menuOverlay",
        { [className || "show"]: isVisible },
        { overlaySpinner: showOverlaySpinner }
      ),
    [className, isVisible, showOverlaySpinner]
  );

  const additionalProps = useMemo(() => {
    return isIgnoredClickOutside ? { [IgnoreClickOutsideAttribute]: "" } : null;
  }, [isIgnoredClickOutside]);

  return (
    <div className={classes} onClick={action} {...additionalProps}>
      <div className="overlayContentWrapper">
        {showOverlaySpinner && <VisibleSpinner fullOverlaySpinner />}
        {showOverlayContent && (
          <>
            {title && <h3 className="overlayTitle">{title}</h3>}
            {content && <div className="overlayContent">{content}</div>}
            {action && buttonTitle && (
              <div
                className="overlayButton"
                onClick={e => {
                  e.stopPropagation();
                  action(e);
                }}
              >
                {buttonTitle}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
